/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_GuestInputs */

const en_roster_guest = /** @type {(inputs: Roster_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest`)
};

const es_roster_guest = /** @type {(inputs: Roster_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitado`)
};

const fr_roster_guest = /** @type {(inputs: Roster_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invité`)
};

const de_roster_guest = /** @type {(inputs: Roster_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gast`)
};

const id_roster_guest = /** @type {(inputs: Roster_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamu`)
};

/** @type {(inputs: Roster_GuestInputs) => LocalizedString} */
const ja_roster_guest = en_roster_guest;

/** @type {(inputs: Roster_GuestInputs) => LocalizedString} */
const zh_roster_guest = en_roster_guest;

/** @type {(inputs: Roster_GuestInputs) => LocalizedString} */
const ar_roster_guest = en_roster_guest;

/** @type {(inputs: Roster_GuestInputs) => LocalizedString} */
const it_roster_guest = en_roster_guest;

/** @type {(inputs: Roster_GuestInputs) => LocalizedString} */
const ru_roster_guest = en_roster_guest;

/** @type {(inputs: Roster_GuestInputs) => LocalizedString} */
const pt_roster_guest = en_roster_guest;

/** @type {(inputs: Roster_GuestInputs) => LocalizedString} */
const ko_roster_guest = en_roster_guest;

/**
* | output |
* | --- |
* | "Guest" |
*
* @param {Roster_GuestInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_guest = /** @type {((inputs?: Roster_GuestInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_GuestInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_guest(inputs)
	if (locale === "es") return es_roster_guest(inputs)
	if (locale === "fr") return fr_roster_guest(inputs)
	if (locale === "de") return de_roster_guest(inputs)
	if (locale === "ja") return ja_roster_guest(inputs)
	if (locale === "zh") return zh_roster_guest(inputs)
	if (locale === "ar") return ar_roster_guest(inputs)
	if (locale === "id") return id_roster_guest(inputs)
	if (locale === "it") return it_roster_guest(inputs)
	if (locale === "ru") return ru_roster_guest(inputs)
	if (locale === "pt") return pt_roster_guest(inputs)
	return ko_roster_guest(inputs)
});